module.exports = __webpack_public_path__ + "img/prioritas_sameday_cod_dg.f3aba19f.png";